/**
 * @description
 */

import {fetchData} from '@umu/umu-fetch';

import Api from '../../../../path';
import {EPracticeQuestionStatus} from '@umu/umu-types';

import {EIsSubmitQuestionRight} from './submitQuestion';

// todo add by daoyu
export enum EMarkQuestionStatus {
    CORRECT = 1,
    WRONG = 0,
}

export interface IInput {
    practice_id: number;
    element_id: number;
    question_id: number;
    element_type?: number;
    mark_status: EIsSubmitQuestionRight;
}

export interface IOutput {
    status: EPracticeQuestionStatus;
    is_right: EIsSubmitQuestionRight;
}

export const markQuestion = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_MARK_QUESTION, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
